import { createContext } from 'react';

import {
  AssetInventoryDevice,
  AssetInventorySummary,
  TabKey,
} from '@totem/components/services/assetInventory/v2/types';

interface Context {
  summary: AssetInventorySummary;
  summaryLoading: boolean;
  devices: AssetInventoryDevice[];
  devicesLoading: boolean;
  totalDevices: number;
  activeTab: TabKey;
  setActiveTab: (tab: TabKey) => void;
  openChecks: string[];
  toggleCheck: (key: string) => void;
  showCheck: (key: string) => void;
  showDetails: (finding?: string) => void;
  exportCsv: () => void;
  exporting: boolean;
}

export default createContext<Context>({
  summary: null,
  summaryLoading: true,
  devices: [],
  devicesLoading: true,
  totalDevices: 0,
  activeTab: 'summary',
  setActiveTab: () => {},
  openChecks: [],
  toggleCheck: () => {},
  showCheck: () => {},
  showDetails: () => {},
  exportCsv: () => {},
  exporting: false,
});
